module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
 var colLabel = "col-md-5";
 var colControl = "col-md-7";

 if (['control_gauge_chart', 'control_crosstab'].includes(factoryKey)) {
     colLabel = "col-md-4";
     colControl = "col-md-8";
 }

    ; __append("\r\n\r\n<div class=\"prop-header\"><span class=\"prop-label\" >Data</span></div>\r\n\r\n<div class=\"row\">\r\n    <div class=\"col-md-12 subsection nopadding-r\">\r\n            ")
    ;  if (['control_gauge_chart', 'control_crosstab'].includes(factoryKey)) { 
    ; __append("\r\n                <label class=\"prop-sublabel label-65\">Data Source</label> \r\n            ")
    ;  }
               else { 
    ; __append("\r\n                <label class=\"prop-sublabel label-80\">Data Source</label> \r\n            ")
    ;  } 
    ; __append("\r\n       \r\n        <div>\r\n            <select name=\"dataSourceId\" id=\"dataSource\">\r\n                ")
    ;  if (factoryKey === 'control_crosstab') { 
    ; __append("\r\n                    <option value=\"null\">None</option>\r\n                ")
    ;  }
                   else { 
    ; __append("\r\n                    <option value=\"none\">None</option>\r\n                ")
    ;  } 
    ; __append("\r\n            </select>\r\n        </div>\r\n   </div>\r\n</div>\r\n")
  }
  return __output;

}